import { arrayToString, stringToArray } from 'cron-converter';
import { dayNames, timeOptions } from './constants';

// This is our internal representation of the schedule (we conver this back and forth to a cron-tab)
// Note: timezones are omitted here, we pass them separately
export type InternalSchedule = {
  days: string[];
  times: string[];
};

export const cronToSchedule = (cronExpression?: string): InternalSchedule => {
  if (!cronExpression) {
    return { days: [], times: [] };
  }
  const [minutes, hours, , , daysOfWeek] = stringToArray(cronExpression);

  const days = daysOfWeek.map((index) => dayNames[index]);

  const times = hours
    .flatMap((hour) =>
      minutes.map((minute) => {
        const period = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minute.toString().padStart(2, '0')} ${period}`;
      }),
    )
    .filter((timeString) => timeOptions.includes(timeString));
  return { days, times };
};

export const scheduleToCron = ({ days, times }: InternalSchedule) => {
  if (days.length === 0 || times.length === 0) {
    return '';
  }

  // Parse time strings to hours and minutes
  const timeObjects = times.map((timeStr) => {
    const [time, period] = timeStr.split(' ');
    const [hours, minutes] = time.split(':').map(Number);

    return {
      hour:
        period === 'PM' && hours !== 12 ? hours + 12
        : period === 'AM' && hours === 12 ? 0
        : hours,
      minute: minutes,
    };
  });

  const minutes = [...new Set(timeObjects.map((t) => t.minute))];
  const hours = [...new Set(timeObjects.map((t) => t.hour))];

  // Convert day names to indices
  const dayIndices = days.map((day) => dayNames.indexOf(day));

  // Create arrays for cron-converter
  const cronArray = [
    minutes,
    hours,
    Array.from({ length: 31 }, (_, i) => i + 1), // days of month (all)
    Array.from({ length: 12 }, (_, i) => i + 1), // months (all)
    dayIndices, // days of week
  ];

  return arrayToString(cronArray);
};
